import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Vue from 'vue'

@Module({
  namespaced: true
})
export default class KwixeoTicketsStore extends VuexModule {
  tagsLoaded = false
  tags: KwixeoTickets.Tags = []
  categoriesLoaded = false
  categories: KwixeoTickets.Categories = []
  templatesLoaded = false
  templates: KwixeoTickets.Templates = []

  // Sort a list alphabetically
  @Mutation
  orderList (param: { list: KwixeoInterface.GenericObject[]; key: string }): void {
    const key = param.key
    param.list.sort((a, b) => {
      const aKey = a[key].toLowerCase()
      const bKey = b[key].toLowerCase()
      if (aKey < bKey) return -1
      else if (aKey > bKey) return 1
      else return 0
    })
  }

  // Change the loaded state
  @Mutation
  setTagsLoaded (state = true): void {
    this.tagsLoaded = state
  }

  // Set the tags
  @Mutation
  setTags (tags: KwixeoTickets.Tags): void {
    this.tags = tags
  }

  // Add or update a tag
  @Mutation
  updateTag (tag: KwixeoTickets.Tag): void {
    if (!this.tagsLoaded) {
      return
    }
    const index = this.tags.findIndex(type => type.id === tag.id)
    if (index >= 0) {
      Vue.set(this.tags, index, tag)
    } else {
      this.tags.push(tag)
    }
  }

  // Remove a tag
  @Mutation
  removeTag (tag: KwixeoTickets.Tag): void {
    if (!this.tagsLoaded) {
      return
    }
    const index = this.tags.findIndex(type => type.id === tag.id)
    if (index >= 0) {
      Vue.delete(this.tags, index)
    }
  }

  // Load the tags from api
  @Action
  async loadTags (force = false): Promise<void> {
    if (!this.tagsLoaded || force) {
      const response = await Vue.prototype.$kwTickets.axios.get('/ticket/tag?per_page=500&sort=label')
      await this.context.commit('setTags', response.data.data)
      this.context.commit('setTagsLoaded')
    }
  }

  // Add or update a tag
  @Action
  setTag (tag: KwixeoTickets.Tag): void {
    this.context.commit('updateTag', tag)
    if (this.tagsLoaded) {
      this.context.commit('orderList', { list: this.tags, key: 'label' })
    }
  }

  // Delete a tag
  @Action
  deleteTag (tag: KwixeoTickets.Tag): void {
    this.context.commit('removeTag', tag)
  }



  // Change the loaded state
  @Mutation
  setCategoriesLoaded (state = true): void {
    this.categoriesLoaded = state
  }

  // Set the categories
  @Mutation
  setCategories (categories: KwixeoTickets.Categories): void {
    this.categories = categories
  }

  // Add or update a category
  @Mutation
  updateCategory (category: KwixeoTickets.Category): void {
    if (!this.categoriesLoaded) {
      return
    }
    const index = this.categories.findIndex(type => type.id === category.id)
    if (index >= 0) {
      Vue.set(this.categories, index, category)
    } else {
      this.categories.push(category)
    }
  }

  // Remove a category
  @Mutation
  removeCategory (category: KwixeoTickets.Category): void {
    if (!this.categoriesLoaded) {
      return
    }
    const index = this.categories.findIndex(type => type.id === category.id)
    if (index >= 0) {
      Vue.delete(this.categories, index)
    }
  }

  // Load the categories from api
  @Action
  async loadCategories (force = false): Promise<void> {
    if (!this.categoriesLoaded || force) {
      const response = await Vue.prototype.$kwTickets.axios.get('/ticket/category?per_page=500&sort=label')
      await this.context.commit('setCategories', response.data.data)
      this.context.commit('setCategoriesLoaded')
    }
  }

  // Add or update a category
  @Action
  setCategory (category: KwixeoTickets.Category): void {
    this.context.commit('updateCategory', category)
    if (this.categoriesLoaded) {
      this.context.commit('orderList', { list: this.categories, key: 'label' })
    }
  }

  // Delete a category
  @Action
  deleteCategory (category: KwixeoTickets.Category): void {
    this.context.commit('removeCategory', category)
  }



  // Change the loaded state
  @Mutation
  setTemplatesLoaded (state = true): void {
    this.templatesLoaded = state
  }

  // Set the templates
  @Mutation
  setTemplates (templates: KwixeoTickets.Templates): void {
    this.templates = templates
  }

  // Add or update a template
  @Mutation
  updateTemplate (template: KwixeoTickets.Template): void {
    if (!this.templatesLoaded) {
      return
    }
    const index = this.templates.findIndex(type => type.id === template.id)
    if (index >= 0) {
      Vue.set(this.templates, index, template)
    } else {
      this.templates.push(template)
    }
  }

  // Remove a template
  @Mutation
  removeTemplate (template: KwixeoTickets.Template): void {
    if (!this.templatesLoaded) {
      return
    }
    const index = this.templates.findIndex(type => type.id === template.id)
    if (index >= 0) {
      Vue.delete(this.templates, index)
    }
  }

  // Load the templates from api
  @Action
  async loadTemplates (force = false): Promise<void> {
    if (!this.templatesLoaded || force) {
      const response = await Vue.prototype.$kwTickets.axios.get('/ticket/template?per_page=500&sort=label')
      await this.context.commit('setTemplates', response.data.data)
      this.context.commit('setTemplatesLoaded')
    }
  }

  // Add or update a template
  @Action
  setTemplate (template: KwixeoTickets.Template): void {
    this.context.commit('updateTemplate', template)
    if (this.templatesLoaded) {
      this.context.commit('orderList', { list: this.templates, key: 'label' })
    }
  }

  // Delete a template
  @Action
  deleteTemplate (template: KwixeoTickets.Template): void {
    this.context.commit('removeTemplate', template)
  }
}
